import { ShieldCheck, FileBadge, Truck, Layers } from "lucide-react";
import { SEO } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Motion";

const BLOCKS = [
  {
    icon: FileBadge,
    title: "Certifications & code work",
    items: ["Welders qualified to AWS D1.1 Structural Welding Code — Steel", "AWS D1.2 (aluminum) and D1.6 (stainless) experience", "Welding Procedure Specifications (WPS) available per job", "Welder qualification records provided for engineer review", "Field welding to engineer-of-record details"],
  },
  {
    icon: ShieldCheck,
    title: "Insurance & documentation",
    items: ["$2M commercial general liability", "Commercial auto on every rig", "Written condition reports for maintenance accounts"],
  },
  {
    icon: Layers,
    title: "Materials & processes",
    items: ["Carbon steel: A36/A992 structural, AR400/AR500 wear plate, schedule pipe", "Aluminum: 5052/6061 sheet, plate, and extrusion", "Stainless: 304/316 rail, sheet, and food-adjacent work", "Processes: MIG (GMAW), TIG (GTAW), Stick (SMAW), flux-core (FCAW)", "Oxy-fuel cutting, field drilling & tapping"],
  },
  {
    icon: Truck,
    title: "Mobile rig capability",
    items: ["Self-contained gas welder/generator — no site power required", "Onboard plate, angle, tube, and flat bar stock for same-visit repairs", "Rig access: fits standard gates and job-site entrances", "Off-road capable for ranch and acreage calls"],
  },
];

const Capabilities = () => (
  <main data-testid="capabilities-page">
    <SEO
      title="Welding Capabilities & Certifications — Aledo Welding | AWS D1.1, Insured"
      description="Contractor-facing capabilities: AWS D1.1 qualified welders, $2M GL insurance, steel/aluminum/stainless, MIG/TIG/Stick, self-contained mobile rigs. Fort Worth, TX."
    />
    <PageHero
      kicker="For contractors, facilities & property managers"
      title="Capabilities, certifications & documentation"
      lede="Everything a qualifying buyer needs to put us on the vendor list: code qualifications, insurance, processes, materials, and rig specs."
      testidPrefix="capabilities"
    />
    <section className="bg-paper pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-px bg-warmline border border-warmline" data-testid="capabilities-grid">
        {BLOCKS.map((b, i) => (
          <Reveal key={b.title} delay={(i % 2) * 0.07}>
            <div className="bg-cream p-7 sm:p-9 h-full" data-testid={`capability-${b.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <b.icon size={30} strokeWidth={1.8} className="text-rust mb-5" aria-hidden />
              <h2 className="font-display font-extrabold tracking-tight text-xl sm:text-2xl">{b.title}</h2>
              <ul className="mt-5 space-y-3">
                {b.items.map((item) => (
                  <li key={item} className="flex gap-3 text-smoke text-[15px] leading-relaxed">
                    <span className="w-2 h-2 bg-steel rotate-45 shrink-0 mt-2" aria-hidden />{item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="mt-10 text-smoke max-w-3xl leading-relaxed" data-testid="capabilities-note">
          Need a prequalification packet, safety manual excerpt, or references from current commercial accounts? Email <a href="mailto:aledowelding@gmail.com" className="text-rust font-semibold hover:text-rust-dark">aledowelding@gmail.com</a> with "Vendor packet" in the subject and we'll send it the same business day.
        </p>
      </Reveal>
    </section>
  </main>
);

export default Capabilities;
